import React from "react";
import { connect } from "react-redux";
import { SketchPicker } from "react-color";
import {
    Input,
    Row,
    ListGroupItem,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Col,
    Button,
    ButtonGroup,
    Collapse,
    Alert,
    DropdownToggle,
    ButtonDropdown,
    DropdownMenu,
    DropdownItem,
    Badge,
    Card,
    Label,
    CardBody
} from "reactstrap";
import { units } from "../../../../../common/units";
import { templateActions } from "../../../../../store/actions/cms/template/template.action";
import { DropDownFacade } from "../../../../../components/UI/Buttons/DropDownFacade";
import ColorPickerFacade from "../../../../../components/UI/Buttons/ColorPickerFacade";
import SystemLabel from "../../../../../system/SystemLabel/SystemLabel";
import Slider, { createSliderWithTooltip } from "rc-slider";
import JirangoFontPicker from "../../../../../fonts/FontPicker";
import { deepClone } from "../../../../../helpers/objectHelper";
import { securityHelper } from "../../../../../helpers/securityHelper";
const SliderWithTooltip = createSliderWithTooltip(Slider);

class ChartSettings extends React.Component {
    handleUpdate = template => {
        const { dispatch } = this.props;
        dispatch(templateActions.softUpdate(template));
    };
    toggleDropDown = path => {
        const names = path.split(".");
        this.setState({
            [names[0]]: { [names[1]]: !this.state[names[0]][names[1]] }
        });
    };

    setAttribute = (attr, path) => {
        const { template } = this.props;
        const names = path.split(".");
        let templateCopy = deepClone(template);

        if (names.length === 3) {
            templateCopy.content[names[0]][names[1]][names[2]] = attr;
        } else {
            templateCopy.content[names[0]][names[1]] = attr;
        }
        this.handleUpdate(templateCopy);
    };
    handleUnitChange = (unit, path) => {
        const { template } = this.props;
        const names = path.split(".");
        let templateCopy = deepClone(template);
        const currentUnit = templateCopy.content[names[0]][names[1]].replace(
            /[0-9]/g,
            ""
        );
        templateCopy.content[names[0]][names[1]] = templateCopy.content[names[0]][
            names[1]
        ].replace(currentUnit, unit);
        if (unit === "auto") {
            templateCopy.content[names[0]][names[1]] = unit;
        }
        this.handleUpdate(templateCopy);
    };

    handleChange = (color, e, path) => {
        const { template } = this.props;
        const names = path.split(".");
        let value = null;
        let templateCopy = deepClone(template);
        if (
            [names[1]].toString() === "fontWeight" ||
            [names[1]].toString() === "fontFamily"
        ) {
            value = e.target.value;
        } else if (color) {
            const { r, g, b, a } = color.rgb;
            value = `rgba(${r},${g},${b},${a})`;
        } else {
            value =
                e.target.value +
                templateCopy.content[names[0]][names[1]].replace(/[0-9\d.-]/g, "");
        }

        if (names.length === 2) {
            templateCopy.content[names[0]][names[1]] = value;
        } else if (names.length === 3) {
            templateCopy.content[names[0]][names[1]][names[2]] = value;
        } else {
            templateCopy.content[names[0]][names[1]] = value;
        }
        this.handleUpdate(templateCopy);
    };
    renderColors = (palette, template) => {
        let ret = [];
        for (const key in palette) {
            if (palette.hasOwnProperty(key)) {
                ret.push(
                    <Row key={key}>
                        <Col className="list-setting-item-title">
                            <Label>
                                <SystemLabel name={`PaletteColor${key}`} />
                            </Label>
                        </Col>
                        <Col className="list-setting-item-input">
                            <ColorPickerFacade
                                color={
                                    template
                                        ? template.content.chart.colors[key]
                                        : ""
                                }
                                onChange={(color, e) =>
                                    this.handleChange(color, e, `chart.colors.${key}`)
                                }
                                path={`chart.colors-${key}`}
                            />
                        </Col>
                    </Row>
                )
            }

        }
        return ret;
    }
    render() {
        const { template } = this.props;
        if (template === undefined) return null;
        const palette = template.content.chart.colors;
        const alpha = ['A', 'B', 'C', 'D', 'E']
        return (
            <div style={{ paddingTop: "10px" }}>
                {this.renderColors(palette, template)}
                <hr/>
                <Row >
                    <Col className="list-setting-item-title">
                        <Label>
                            <SystemLabel name={`TextflowColor`} />
                        </Label>
                    </Col>
                    <Col className="list-setting-item-input">
                        <ColorPickerFacade
                            color={
                                template
                                    ? template.content.chart.textflowColor
                                    : ""
                            }
                            onChange={(color, e) =>
                                this.handleChange(color, e, `chart.textflowColor`)
                            }
                            path={`chart.textflowColor`}
                        />
                    </Col>
                </Row>
            
                <Row >
                    <Col className="list-setting-item-title">
                        <Label>
                            <SystemLabel name={`TextflowBgColor`} />
                        </Label>
                    </Col>
                    <Col className="list-setting-item-input">
                        <ColorPickerFacade
                            color={
                                template
                                    ? template.content.chart.textflowBgColor
                                    : ""
                            }
                            onChange={(color, e) =>
                                this.handleChange(color, e, `chart.textflowBgColor`)
                            }
                            path={`chart.textflowBgColor`}
                        />
                    </Col>
                </Row>
            </div>
        );
    }
}
function mapStateToProps(state) {
    return {
        alert: state.alert,
        template: state.template.template
    };
}
export default connect(mapStateToProps)(ChartSettings);
